var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "noticestyle" },
    [
      _c("h2", [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _c(
        "el-form",
        { attrs: { "label-width": "80px", model: _vm.datas, size: "small" } },
        [
          _c(
            "el-form-item",
            { staticClass: "lef", attrs: { label: "框体内容" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入内容" },
                model: {
                  value: _vm.datas.content,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "content", $$v)
                  },
                  expression: "datas.content",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticStyle: { height: "20px" } }),
          _vm._v(" "),
          _c(
            "el-form-item",
            { staticClass: "lef", attrs: { label: "框体样式" } },
            [
              _c("el-slider", {
                attrs: {
                  max: 20,
                  min: 0,
                  "input-size": "mini",
                  "show-input": "",
                },
                model: {
                  value: _vm.datas.borderRadius,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "borderRadius", $$v)
                  },
                  expression: "datas.borderRadius",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticStyle: { height: "10px" } }),
          _vm._v(" "),
          _c(
            "el-form-item",
            { staticClass: "lef borrediu", attrs: { label: "框体高度" } },
            [
              _c("el-slider", {
                attrs: {
                  max: 50,
                  min: 1,
                  "input-size": "mini",
                  "show-input": "",
                },
                model: {
                  value: _vm.datas.height,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "height", $$v)
                  },
                  expression: "datas.height",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticStyle: { height: "10px" } }),
          _vm._v(" "),
          _c(
            "el-form-item",
            { staticClass: "lef", attrs: { label: "展示图标" } },
            [
              _c("el-switch", {
                model: {
                  value: _vm.datas.showIcon,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "showIcon", $$v)
                  },
                  expression: "datas.showIcon",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { staticClass: "lef", attrs: { label: "背景颜色" } },
            [
              _c("el-color-picker", {
                staticClass: "picke",
                attrs: { "show-alpha": "", predefine: _vm.predefineColors },
                model: {
                  value: _vm.datas.backgroundColor,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "backgroundColor", $$v)
                  },
                  expression: "datas.backgroundColor",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticStyle: { height: "10px" } }),
          _vm._v(" "),
          _c(
            "el-form-item",
            { staticClass: "lef", attrs: { label: "文本颜色" } },
            [
              _c("el-color-picker", {
                staticClass: "picke",
                attrs: { "show-alpha": "", predefine: _vm.predefineColors },
                model: {
                  value: _vm.datas.textColor,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "textColor", $$v)
                  },
                  expression: "datas.textColor",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              staticClass: "lef",
              attrs: {
                label: "字体大小",
                prop: "textSize",
                "hide-required-asterisk": true,
              },
            },
            [
              _c("el-input", {
                attrs: { type: "number", placeholder: "请输入字体大小" },
                model: {
                  value: _vm.datas.textSize,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas, "textSize", _vm._n($$v))
                  },
                  expression: "datas.textSize",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              staticClass: "lef",
              attrs: {
                label: "显示更多",
                prop: "textSize",
                "hide-required-asterisk": true,
              },
            },
            [
              _c("el-checkbox", {
                model: {
                  value: _vm.datas.more.show,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas.more, "show", $$v)
                  },
                  expression: "datas.more.show",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticStyle: { height: "10px" } }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.datas.more.show ? true : false,
                  expression: "datas.more.show ? true : false",
                },
              ],
            },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.datas.more.type,
                    callback: function ($$v) {
                      _vm.$set(_vm.datas.more, "type", $$v)
                    },
                    expression: "datas.more.type",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 0 } }, [_vm._v("样式一")]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 1 } }, [_vm._v("样式二")]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 2 } }, [_vm._v("样式三")]),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticStyle: { height: "10px" } }),
              _vm._v(" "),
              _c("el-input", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.datas.more.type === 2 ? false : true,
                    expression: "datas.more.type === 2 ? false : true",
                  },
                ],
                staticStyle: { width: "110px", margin: "15px" },
                attrs: { type: "text", size: "mini" },
                model: {
                  value: _vm.datas.more.text,
                  callback: function ($$v) {
                    _vm.$set(_vm.datas.more, "text", $$v)
                  },
                  expression: "datas.more.text",
                },
              }),
              _vm._v(" "),
              _c("div", { staticStyle: { height: "10px" } }),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "跳转链接" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      staticStyle: { "margin-left": "18px" },
                      on: { change: _vm.handleHttpTypeChange },
                      model: {
                        value: _vm.datas.more.httpType,
                        callback: function ($$v) {
                          _vm.$set(_vm.datas.more, "httpType", $$v)
                        },
                        expression: "datas.more.httpType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 10 } }, [
                        _vm._v("内部链接"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 11 } }, [
                        _vm._v("外部链接"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.datas.more.httpType === 10
                    ? _c(
                        "el-select",
                        {
                          staticStyle: { "margin-top": "10px", width: "100%" },
                          attrs: {
                            placeholder: "请选择内部页面",
                            filterable: "",
                            clearable: "",
                            loading: _vm.loadingPageList,
                          },
                          on: { change: _vm.handlePageChange },
                          model: {
                            value: _vm.datas.more.http,
                            callback: function ($$v) {
                              _vm.$set(_vm.datas.more, "http", $$v)
                            },
                            expression: "datas.more.http",
                          },
                        },
                        _vm._l(_vm.pageList, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      )
                    : _c("el-input", {
                        staticStyle: { "margin-top": "10px" },
                        attrs: {
                          placeholder: "请输入跳转链接",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.datas.more.http,
                          callback: function ($$v) {
                            _vm.$set(_vm.datas.more, "http", $$v)
                          },
                          expression: "datas.more.http",
                        },
                      }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }